import { Component, Input, OnInit, inject } from '@angular/core';
import { Auth, onAuthStateChanged } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Navigation } from 'src/app/enums/navigation.enum';
import { Event } from 'src/app/models/event';
import { EventService } from 'src/app/services/event.service';

@Component({
    selector: 'app-event-create',
    templateUrl: './event-create.component.html',
    styleUrls: ['./event-create.component.scss'],
    standalone: false
})
export class EventCreateComponent implements OnInit {
  
  @Input() redirectOnSuccess = true;
  @Input() raceId;
  @Input() referees;
  modalId = 'event-create-modal';
  event: Event;
  signedIn = false;
  user;
  public auth = inject(Auth);
  private _event: Event = new Event();
  private authSubscription?;
  constructor(
    private _router: Router,
    private _eventService: EventService,
    private _modalService: NgbModal,
  ) {
    this.authSubscription = onAuthStateChanged(this.auth, (u) => {
      if (u) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/auth.user
        this.signedIn = true
        this.user = u
        // ...
      } else {
        // User is signed out
        this.signedIn = false
        this.user = null;
      }
    });
  }

  ngOnInit(): void {
    this._event.raceId = this.raceId;
    this._event.referees = this.referees;
    this.event = Object.assign({}, this._event);
  }
  ngOnDestroy(): void {
    if(this.authSubscription) {
      // unsubscribes
      this.authSubscription();
    }
  }
  async add() {
    const id = await this._eventService.add(this.event);
    this._modalService.dismissAll();
    if(this.redirectOnSuccess){
      this._router.navigate([Navigation.EventDetail, id]);
    }
  }
  open(content) {
    this._modalService.open(content, {ariaLabelledBy: this.modalId, centered: true}).result.then((result) => {
      this.event = Object.assign({}, this._event);
    }, (reason) => {
      this.event = Object.assign({}, this._event);
    });
  }

}
